import React, { useState, useEffect } from "react";
import {
  FormGroup,
  TextField,
  FormControlLabel,
  Switch,
  Stack,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Api from "../../network/Api";
import User from "../../types/User";
import Workspace from "../../types/Workspace";
import OnboardingLayout from "./Layout";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

export type OnboardingProps = {
  user: User;
};

export type WorkspaceOnboardingParams = {
  name?: string;
  domain_whitelist?: "true" | "false"
  website?: string;
  domain?: string;
  hourly_rate?: string;
};

const WorkspaceOnboarding = (props: OnboardingProps) => {
  const [workspace, setWorkspace] = useState<Workspace>();
  const [params, setParams] = useState<WorkspaceOnboardingParams>({});
  const [isLoading, shouldLoad] = useState<boolean>(false);

  useEffect(() => {
    Api.get(`/workspace`).then(result => {
      setWorkspace(result);
      setParams({...params, ...result});
    });
  }, []);

  useEffect(() => {
    if (!isLoading) { return }
    Api.put(`/workspace`, params).then(result => { window.location.reload() });
  }, [isLoading]);

  const hostFrom = (urlString?: string) => {
    if (!urlString) { return null }
    if (!params.domain_whitelist) {
      setParams({...params, domain_whitelist: "true"});
    }
    try {
      if (!urlString.startsWith('http://') && !urlString.startsWith('https://')) {
          urlString = `http://${urlString}`;
      }
      const url = new URL(urlString);
      return url.host.replace("www.", "");
    } catch (error) {
      return null;
    }
  }

  return (
    <OnboardingLayout activeStep={workspace?.website ? 2 : 1}><>
      {workspace && <>
        <FormGroup>
          <TextField
            name="name"
            label="Name of workspace"
            defaultValue={workspace.name}
            variant="filled"
            required
            onChange={(e) => {
              setParams({ ...params, name: e.target.value });
            }}
          />
        </FormGroup>
        
        <FormGroup>
          <TextField
            name="website"
            label="Company or project website"
            defaultValue={workspace.website}
            variant="filled"
            required
            onChange={(e) => {
              setParams({ ...params, website: e.target.value });
            }}
          />
        </FormGroup>

        {hostFrom(params.website) && (
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  onChange={(e) => {
                    setParams({
                      ...params,
                      domain_whitelist: e.target.value.toString(),
                    });
                  }}
                  defaultChecked={params.domain_whitelist != "false"}
                />
              }
              label={<span className="text-secondary">Let anyone with a <strong>@{hostFrom(params.website)}</strong> email join this workspace automatically.</span>}
            />
          </FormGroup>
        )}
        <Stack direction="row" spacing={1} justifyContent={"flex-end"}>
          <LoadingButton loading={isLoading} disabled={!hostFrom(params.website)} variant="outlined" onClick={() => shouldLoad(true)} endIcon={<ArrowRightAltIcon />}>Next</LoadingButton>
        </Stack>
      </> }
    </></OnboardingLayout>
  );
};

export default WorkspaceOnboarding;
